'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ADVISOR_HOST = 'https://advisors-static.ownup.com';

var advisorsJSON = null;

exports.default = function () {
  if (advisorsJSON === null) {
    advisorsJSON = fetch(ADVISOR_HOST + '/index.json', {
      mode: 'cors',
      method: 'GET',
      cache: 'default',
      credentials: 'omit',
      redirect: 'follow'
    }).then(function (resp) {
      if (resp.ok) {
        return resp.json();
      } else {
        throw new Error(resp.statusText);
      }
    }).then(function (json) {
      var fixURLValue = function fixURLValue(elem) {
        if ((typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object') {
          if (Array.isArray(elem)) {
            return elem.map(function (e) {
              return fixURLValue(e);
            });
          }
          return Object.keys(elem).map(function (key) {
            return _defineProperty({}, key, fixURLValue(elem[key]));
          }).reduce(function (acc, obj) {
            return Object.assign(acc, obj);
          }, {});
        }
        if (typeof elem === 'string' && elem.startsWith('./')) {
          return ADVISOR_HOST + '/' + elem.substr(2); // remove ./
        }
        return elem;
      };
      return fixURLValue(json);
    }, function (err) {
      console.error('unable to load advisor data', err);
      return {};
    });
  }
  return advisorsJSON;
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/advisors.js